<template>
    <section class="admin">
        <Loader :loading="loader" :fixed="true"></Loader>

        <p class="admin-user-title" v-if="user">{{ user.firstname.toUpperCase() }} {{ user.lastname.toUpperCase() }}</p>

        <div class="admin-user" v-if="user">
            <div class="row">
                <div class="col-12 col-md-10">
                    <div class="admin-user-infos table-responsive">
                        <table>
                            <tr>
                                <th>{{ $t("createUser.labelEmail") }}:</th>
                                <td>{{ user.email }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t("userList.lastConnection") }} :</th>
                                <td>
                                    <template v-if="user.lastConnectionDate">
                                        {{ getDateByFormat(user.lastConnectionDate, "DD/MM/YYYY HH:mm") }}
                                    </template>
                                    <template v-else>-</template>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div class="row mt-5" v-if="userBrandsFiltered.length">
                        <div class="col-12 col-md">
                            <p class="messageAccessBrand mb-4">{{ $t("userrole.messageAccessBrand") }}</p>
                            <div class="row d-flex flex-row justify-content-center justify-content-sm-start">
                                <div
                                    v-for="(userBrand, key) in userBrandsFiltered"
                                    v-bind:key="key"
                                    v-if="(isSuperAdmin() || isClientAdmin(userBrand.brand.id)) && userBrand.brand.id !== currentBrand.id"
                                    class="px-4 pb-3"
                                    style="flex-basis: 250px;flex-grow: 0;"
                                >
                                    <ClientColorButton background-color="#727a96" width="100%" @click="changeBrand(userBrand.brand)">
                                        {{ userBrand.brand.name }}
                                    </ClientColorButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-2 d-flex flex-column">
                    <div class="d-flex align-items-center justify-content-center flex-column" style="flex: 1 1 auto">
                        <ClientColorButton :inactive-color="true" class="mb-4 w-100" @click="openModalEditUser()">{{
                            $t("userAdmin.edit_info")
                        }}</ClientColorButton>
                        <!--
                            <ClientColorButton v-if="!user.isSsoEnabled" :inactive-color="true" class="mb-4 w-100">{{ $t("userAdmin.reset_password") }}</ClientColorButton>
                        -->
                        <ClientColorButton :inactive-color="true" class="mb-4 w-100" @click="openModalDeleteBrand()">{{
                            $t("userAdmin.delete_from_brand")
                        }}</ClientColorButton>
                        <ClientColorButton v-if="isSuperAdmin()" :inactive-color="true" @click="openModalChangeAccess()" class="w-100 mb-4">{{
                            $t(user.isEnabled ? "userAdmin.disable_user" : "userAdmin.enable_user")
                        }}</ClientColorButton>
                        <template v-if="isSuperAdmin()">
                            <ClientColorButton
                                v-if="!user.isSsoEnabled"
                                :inactive-color="true"
                                class="mb-4 w-100"
                                @click="resetLoginAttempts(user.id)"
                            >
                                {{ $t("plano.buttonLoginAttempts") }}
                            </ClientColorButton>
                            <ClientColorButton
                                v-else
                                v-b-tooltip.hover.bottom="'SSO mode enable for this user, this action is forbidden'"
                                :inactive-color="true"
                                class="mb-4 w-100"
                            >
                                {{ $t("plano.buttonLoginAttempts") }}
                            </ClientColorButton>
                        </template>

                        <DeleteBrand v-if="modalParamsDeleteBrand" :params="modalParamsDeleteBrand" @loadUsers="close()"></DeleteBrand>
                        <ChangeAccess v-if="modalParamsChangeAccess" :params="modalParamsChangeAccess" @loadUsers="getInfosUser(true)"></ChangeAccess>
                        <UserEdit v-if="user && modalParamsEditUser" :params="modalParamsEditUser" @reload="getInfosUser(true)"></UserEdit>
                    </div>
                    <div class="d-flex justify-content-end">
                        <History :object="user" :object-type="OBJECT_TYPE.USERS" :is-dark="false" :is-grey="true"></History>
                    </div>
                </div>
            </div>
        </div>

        <div class="admin-role mt-5" v-if="getBrandAccess && getBrandAccess.length && brandAccessFiltered.length && user">
            <div class="row mb-4">
                <div class="col">
                    <span class="admin-role-title">{{ $t("userrole.rights") }} :</span>
                </div>
                <div class="col-auto">
                    <ClientColorButton v-if="brandZonesFiltered.length" :color="currentBrand.colorLinks" @click="save">{{
                        $t("common.save")
                    }}</ClientColorButton>
                </div>
            </div>

            <div v-if="user.userType === 0" class="d-flex align-items-center my-4 admin-role-switch-client-admin">
                <span class="mr-3">{{ $t("userrole.isSuperAdmin") }}</span>
                <label class="switch switch-m" for="switchSuperAdmin" id="'tooltipSuperAdmin'">
                    <input
                        type="checkbox"
                        id="switchSuperAdmin"
                        @input="changeSuperAdmin($event)"
                        :checked="user.isSuperAdmin"
                        v-if="isSuperAdmin()"
                    />
                    <span class="slider round" :style="{ 'background-color': user.isSuperAdmin ? currentBrand.linksColor : '' }"></span>
                </label>
                <b-tooltip v-if="!isSuperAdmin()" target="tooltipSuperAdmin" placement="right">
                    <span>{{ $t("userrole.noRight") }}</span>
                </b-tooltip>
            </div>

            <div v-if="user.userType === 1 && isSuperAdmin()" class="d-flex align-items-center my-4 admin-role-switch-client-admin">
                <span class="mr-3">{{ $t("userrole.isClientAdmin") }}</span>
                <label class="switch switch-m" for="switchClientAdmin" id="tooltipClientAdmin">
                    <input
                        type="checkbox"
                        id="switchClientAdmin"
                        @input="changeClientAdmin($event)"
                        :checked="isUserClientAdmin"
                        :disabled="!(isSuperAdmin() || isClientAdmin())"
                    />
                    <span class="slider round" :style="{ 'background-color': isUserClientAdmin ? currentBrand.linksColor : '' }"></span>
                </label>
                <b-tooltip v-if="!(isSuperAdmin() || isClientAdmin())" target="tooltipClientAdmin" placement="right">
                    <span>{{ $t("userrole.noRight") }}</span>
                </b-tooltip>
            </div>

            <div v-if="!user.isSuperAdmin">
                <b-tabs content-class="mt-3">
                    <b-tab
                        v-for="(brandAccess, key) in brandAccessFiltered"
                        v-bind:key="key"
                        :title="getTranslate(brandAccess.terms.name)"
                        v-if="displayTab(brandAccess.application)"
                        :active="rightsUserTab ? key === parseInt(rightsUserTab, 10) : key === 0"
                        @click="changeApp(brandAccess, key)"
                    >
                        <div class="row mt-4">
                            <div class="col">
                                <input type="text" id="searchBySearch" v-model="search" class="rem3rch-input-text" />
                                <label for="searchBySearch" class="m-0 pointer ml-3"><i class="fa fa-search fa-lg color-grey"></i></label>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="table-responsive-old">
                                    <table class="admin-role-table">
                                        <thead>
                                            <tr>
                                                <th colspan="5">
                                                    <div class="row d-flex align-items-center">
                                                        <div class="col-auto">
                                                            <ClientColorButton class="mt-4" :inactive-color="true" @click="selectAll()">{{
                                                                $t("common.selectAll")
                                                            }}</ClientColorButton>
                                                        </div>
                                                        <div class="col-auto">
                                                            <ClientColorButton class="mt-4" :inactive-color="true" @click="selectNone()">{{
                                                                $t("common.selectNone")
                                                            }}</ClientColorButton>
                                                        </div>
                                                        <div class="col-auto">
                                                            <ClientColorButton class="mt-4" :inactive-color="true" @click="resetSelectedProfiles()">{{
                                                                $t("common.resetSelection")
                                                            }}</ClientColorButton>
                                                        </div>
                                                        <div class="col-auto d-flex admin-role-filter mt-4">
                                                            <Multiselect
                                                                class="mr-5"
                                                                v-model="filteredProfile"
                                                                :options="profiles"
                                                                :label="'name'"
                                                                track-by="name"
                                                                :multiple="false"
                                                                :select-label="''"
                                                                :searchable="false"
                                                                :close-on-select="true"
                                                                :show-labels="true"
                                                                :placeholder="$t('userrole.filterProfile')"
                                                                :deselect-label="$t('common.delete')"
                                                            />
                                                            <Multiselect
                                                                v-model="filteredGroup"
                                                                :options="zoneGroups"
                                                                :label="'name'"
                                                                track-by="name"
                                                                :multiple="false"
                                                                :select-label="''"
                                                                :searchable="false"
                                                                :close-on-select="true"
                                                                :show-labels="true"
                                                                :placeholder="$t('userrole.filterGroup')"
                                                                :deselect-label="$t('common.delete')"
                                                            />
                                                        </div>
                                                    </div>
                                                </th>
                                                <th class="header-profile admin-role-filter mt-4">
                                                    <Multiselect
                                                        v-if="checkedZones.length > 0"
                                                        v-model="multiProfileUpdate"
                                                        :options="profilesFiltered"
                                                        :label="'name'"
                                                        track-by="name"
                                                        :multiple="false"
                                                        :select-label="''"
                                                        :searchable="false"
                                                        :close-on-select="true"
                                                        :show-labels="true"
                                                        :placeholder="$t('userrole.selectProfile')"
                                                        :deselect-label="$t('common.delete')"
                                                        @input="updateCheckedZonesProfile(multiProfileUpdate)"
                                                    />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="!changingTab">
                                            <tr v-for="(brandZone, key) in brandZonesFiltered" v-bind:key="key">
                                                <td class="color" :style="{ backgroundColor: getProfileColor(brandZone.zone.id) }"></td>
                                                <td class="checkbox">
                                                    <template v-if="profileCanBeUpdated(seletedProfileByZone[brandZone.zone.id])">
                                                        <label
                                                            :for="'checkbox_zone_' + brandZone.zone.id"
                                                            class="label-checkbox pointer mb-0 d-flex align-items-center justify-content-center"
                                                        >
                                                            <span
                                                                v-show="checkedZones.includes(brandZone.zone.id)"
                                                                @click="checkZone(brandZone.zone.id, false)"
                                                                class="rem3rch-checkbox rem3rch-checkbox"
                                                            >
                                                                <i class="fa fa-check"></i>
                                                            </span>
                                                            <span
                                                                v-if="!checkedZones.includes(brandZone.zone.id)"
                                                                @click="checkZone(brandZone.zone.id, true)"
                                                                class="rem3rch-checkbox rem3rch-checkbox"
                                                            ></span>
                                                        </label>
                                                    </template>
                                                </td>
                                                <td class="ref">{{ brandZone.zone.refClient }}</td>
                                                <td class="name">{{ brandZone.zone.name }}</td>
                                                <td class="zoneGroup">
                                                    <template v-if="getBrandZone(brandZone.zone.id) && brandZone.zoneGroupsRights">
                                                        {{ brandZone.zoneGroupsRights.name }}
                                                    </template>
                                                </td>
                                                <td class="profile">
                                                    <Multiselect
                                                        v-model="seletedProfileByZone[brandZone.zone.id]"
                                                        :options="profilesFiltered"
                                                        :label="'name'"
                                                        track-by="name"
                                                        :multiple="false"
                                                        :select-label="''"
                                                        :searchable="false"
                                                        :close-on-select="true"
                                                        :show-labels="true"
                                                        :placeholder="$t('userrole.selectProfile')"
                                                        :deselect-label="$t('common.delete')"
                                                        :disabled="!profileCanBeUpdated(seletedProfileByZone[brandZone.zone.id])"
                                                    />
                                                </td>
                                                <td class="view-zone text-center">
                                                    <ClientColorButton
                                                        @click="$router.push({ path: '/zones/zone/' + brandZone.zone.id })"
                                                        :inactive-color="true"
                                                        >{{ $t("userrole.viewZone") }}</ClientColorButton
                                                    >
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div v-if="!brandZonesFiltered.length" class="d-flex align-items-center justify-content-center notfound">
                                        <span>{{ $t("zonerole.notfound") }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>

                <div class="d-flex justify-content-center mt-4">
                    <ClientColorButton :inactive-color="true" @click="close" class="mr-3">{{ $t("common.cancel") }}</ClientColorButton>
                    <ClientColorButton v-if="brandZonesFiltered.length" :color="currentBrand.colorLinks" @click="save">{{
                        $t("common.save")
                    }}</ClientColorButton>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import http from "../../service";
import Spinner from "vue-simple-spinner";
import cacheService from "@/services/cache";
import userService from "@/services/user";
import AppSection from "@/components/admin/user/AppSection";
import CheckBoxModal from "@/components/common/CheckBoxModal";
import Multiselect from "vue-multiselect";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import Loader from "@/components/loader/loader";
import currentBrand from "@/services/currentBrand";
import History from "@/components/history/History";
import { APPLICATION } from "@/components/admin/brand/constant";
import { PROFILES } from "@/plugins/AccessUserPlugin";
import DeleteBrand from "@/components/users/actions/DeleteBrand";
import ChangeAccess from "@/components/users/actions/ChangeAccess";
import UserEdit from "@/components/users/actions/UserEdit";
import { BTooltip } from "bootstrap-vue";
import { FUNCTIONALITY } from "@/components/tools/constants";

const d3 = require("d3"); // eslint-disable-line no-unused-vars

export default {
    components: {
        UserEdit,
        ChangeAccess,
        DeleteBrand,
        History,
        Loader,
        Spinner,
        AppSection,
        CheckBoxModal,
        Multiselect,
        "b-tooltip": BTooltip
    },
    props: ["checkedOption"],
    data() {
        return {
            brands: cacheService.getBrands(),
            access: null,
            checkedZones: [],
            seletedProfileByZone: [],
            tmpSeletedProfileByZone: [],
            profiles: [],
            superadmin: false,
            loader: true,
            user: null,
            accessApplication: [],
            currentZone: null,
            isCheckBoxModalVisible: false,
            search: "",
            currentApp: null,
            OBJECT_TYPE,
            filteredProfile: null,
            filteredGroup: null,
            multiProfileUpdate: null,
            rightsUserTab: localStorage.getItem("rights_tab"),
            modalParamsDeleteBrand: null,
            modalParamsChangeAccess: null,
            modalParamsEditUser: null,
            changingTab: false
        };
    },
    async created() {
        this.loader = true;

        await this.findBrandAccess(cacheService.getCurrentBrandId());

        if (this.brandAccessFiltered.length) {
            if (localStorage.getItem("rights_tab")) {
                const brandAccess = this.brandAccessFiltered[localStorage.getItem("rights_tab")];
                if (brandAccess) {
                    this.currentApp = brandAccess.application;
                } else {
                    this.currentApp = this.brandAccessFiltered[0].application;
                }
            } else {
                this.currentApp = this.brandAccessFiltered[0].application;
            }
            await this.findAllProfileAccess({ id: this.$route.params.id, appId: this.currentApp });
        }

        await Promise.all([
            await this.findAllApplicationProfile(),
            await this.findAllFunctionalitiesAccess(this.$route.params.id),
            await this.getInfosUser(),
            await this.findAllRolesComplet(),
            await this.populateAdminBrandZones({ app: this.currentApp, reload: true })
        ]);

        await this.init();

        this.loader = false;
    },
    mounted() {},
    beforeDestroy() {
        this.cleanFunctionalitiesAccess();
        this.access = null;
    },
    computed: {
        ...mapGetters({
            getApplicationProfile: "user/getApplicationProfile",
            getBrandAccess: "brand/getBrandAccess",
            getRolesComplete: "roles/getRolesComplete",
            getAllApplications: "functionality/getAllApplications",
            getFunctionalitiesAccess: "user/getFunctionalitiesAccess",
            getProfileAccess: "user/getProfileAccess",
            getAllUsersList: "user/getAllUsersList"
        }),
        ...mapGetters("forecast", { brandZones: "getAdminBrandZones" }),
        ...mapGetters("currentUser", ["currentProfiles"]),
        ...mapState("currentUser", ["currentBrand"]),
        brandZonesFiltered() {
            const checkedZones = [];
            const filteredBrandZones = this.brandZones
                .filter(bz => bz.active)
                .filter(bz => {
                    return (
                        this.search === "" ||
                        bz.zone.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                        (bz.zone.refClient && bz.zone.refClient.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                        (bz.zoneGroupsRights && bz.zoneGroupsRights.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
                    );
                })
                .filter(bz => {
                    const zoneProfile = this.seletedProfileByZone ? this.seletedProfileByZone[bz.zone.id] : null;
                    if (this.filteredProfile) {
                        if (zoneProfile) {
                            return zoneProfile.name === this.filteredProfile.name;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                    return true;
                })
                .filter(bz => {
                    const brandZone = this.getBrandZone(bz.zone.id);
                    if (this.filteredGroup) {
                        if (bz.zoneGroupsRights) {
                            return bz.zoneGroupsRights.name === this.filteredGroup.name;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                    return true;
                });
            filteredBrandZones.forEach(bz => {
                this.checkedZones.forEach(zoneId => {
                    if (bz.zone.id === zoneId) {
                        checkedZones.push(zoneId);
                    }
                });
            });
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.checkedZones = checkedZones;
            return filteredBrandZones;
        },
        zoneGroups() {
            const zoneGroupList = [];
            this.brandZones.forEach(bz => {
                if (bz.zoneGroupsRights && !zoneGroupList[bz.zoneGroupsRights.id]) {
                    zoneGroupList[bz.zoneGroupsRights.id] = bz.zoneGroupsRights;
                }
            });
            return zoneGroupList;
        },
        brandAccessFiltered() {
            const brandAccess = this.getBrandAccess.filter(
                ba => ba.application === APPLICATION.FORECAST_ID || ba.application === APPLICATION.CATALOG_FORECAST_ID
            );

            return brandAccess.sort((a, b) => (a.application > b.application ? 1 : b.application > a.application ? -1 : 0));
        },
        isUserClientAdmin() {
            return this.user.userBrand.some(ub => ub.brand.id === this.currentBrand.id && ub.isClientAdmin);
        },
        userBrandsFiltered() {
            if (!this.user || !this.user.userBrand) {
                return [];
            }

            // On enlève la Marque sur laquelle on est actuellement
            const filteredUserBrands = this.user.userBrand.filter(ub => ub.brand.id !== this.currentBrand.id);

            // Tri par ordre alphabétique des noms des Marques
            const orderedUserBrands = filteredUserBrands.sort((userBrandA, userBrandB) => {
                if (userBrandA.brand.name.toLowerCase() < userBrandB.brand.name.toLowerCase()) return -1;
                if (userBrandA.brand.name.toLowerCase() > userBrandB.brand.name.toLowerCase()) return 1;
                else return 0;
            });

            return orderedUserBrands;
        },
        profilesFiltered() {
            const profiles = [];
            if (!this.isSuperAdmin() && !this.isClientAdmin()) {
                const currentProfile = this.currentProfiles.find(p => p.id === this.currentApp);
                if (currentProfile) {
                    const appProfile = this.getApplicationProfile.find(ap => ap.profile.name === currentProfile.profileName);
                    if (appProfile) {
                        this.getApplicationProfile.forEach(ap => {
                            if (ap.application.id === this.currentApp && ap.level < appProfile.level) {
                                profiles.push(ap.profile);
                            }
                        });
                    }
                }
            } else {
                this.getApplicationProfile.forEach(ap => {
                    if (ap.application.id === this.currentApp) {
                        profiles.push(ap.profile);
                    }
                });
            }
            return profiles;
        }
    },
    methods: {
        ...mapActions({
            findBrandAccess: "brand/findBrandAccess",
            getAllUsersListAction: "user/getAllUsersListAction",
            findAllApplications: "functionality/findAllApplications",
            findAllApplicationProfile: "user/findAllApplicationProfile",
            findAllRolesComplet: "roles/findAllRolesComplet",
            findAllFunctionalitiesAccess: "user/findAllFunctionalitiesAccess",
            findAllProfileAccess: "user/findAllProfileAccess",
            cleanFunctionalitiesAccess: "user/cleanFunctionalitiesAccess"
        }),
        ...mapActions("forecast", { populateAdminBrandZones: "populateAdminBrandZones" }),
        ...mapActions("brand/", ["populate"]),
        ...mapActions("currentUser/", ["populateInfo"]),
        async changeBrand(brand) {
            const fullBrand = this.brands.find(b => b.id === brand.id);
            await currentBrand.save(fullBrand, null, this.$accessUser);
            this.populate();
            this.populateInfo();
            location.reload();
        },
        async changeApp(brandAccess, key) {
            this.changingTab = true;
            this.loader = true;
            this.currentApp = brandAccess.application;
            this.selectNone();
            await this.populateAdminBrandZones({ app: this.currentApp, reload: true });
            await this.findAllProfileAccess({ id: this.$route.params.id, appId: this.currentApp });
            await this.init();
            localStorage.setItem("rights_tab", key.toString());
            this.changingTab = false;
            this.loader = false;
        },
        getBrandZone(zoneId) {
            return this.brandZones.find(bz => bz.brand.id === this.currentBrand.id && bz.zone.id === zoneId);
        },
        getProfileColor(zoneId) {
            const profile = this.seletedProfileByZone ? this.seletedProfileByZone[zoneId] : null;
            if (profile) {
                switch (profile.name) {
                    case PROFILES.FORECAST_MANAGER:
                        return "#faa4a4";
                    case PROFILES.ZONE_READER:
                        return "#a7f0fa";
                    case PROFILES.ZONE_FORECASTER:
                        return "#ca9bfc";
                    case PROFILES.ZONES_SUPERVISOR:
                        return "#a4fab1";
                    case PROFILES.COORDINATOR:
                        return "#fae9a4";
                }
            }
            return null;
        },
        selectAll() {
            this.brandZonesFiltered.forEach(bz => {
                if (!this.checkedZones.includes(bz.zone.id)) {
                    this.checkedZones.push(bz.zone.id);
                }
            });
        },
        selectNone() {
            this.checkedZones = [];
        },
        checkZone(zoneId, add) {
            if (add) {
                this.checkedZones.push(zoneId);
            } else {
                this.checkedZones.splice(this.checkedZones.indexOf(zoneId), 1);
            }
        },
        resetSelectedProfiles() {
            const selectProfile = this.$t("userrole.selectProfile");
            this.checkedZones.forEach(zoneId => {
                if ((!this.seletedProfileByZone[zoneId] || this.seletedProfileByZone[zoneId]) && this.tmpSeletedProfileByZone[zoneId]) {
                    this.seletedProfileByZone[zoneId] = Object.assign({}, this.tmpSeletedProfileByZone[zoneId]);
                }
                if (this.seletedProfileByZone[zoneId] && !this.tmpSeletedProfileByZone[zoneId]) {
                    this.seletedProfileByZone[zoneId] = { name: selectProfile };
                }
            });
        },
        updateCheckedZonesProfile(profile) {
            this.checkedZones.forEach(zoneId => {
                this.seletedProfileByZone[zoneId] = profile;
            });
            this.selectNone();
        },
        profileCanBeUpdated(profile) {
            if (!this.profilesFiltered || (this.profilesFiltered && !this.profilesFiltered.length)) {
                return false;
            }
            if (!profile || (profile && !profile.id)) {
                return true;
            }
            return this.profilesFiltered.some(p => p.id === profile.id);
        },
        changeSuperAdmin(event) {
            this.user.isSuperAdmin = event.target.checked;
        },
        changeClientAdmin(event) {
            const userBrand = this.user.userBrand.find(ub => ub.brand.id === this.currentBrand.id);
            if (userBrand) {
                userBrand.isClientAdmin = event.target.checked;
            }
        },
        resetLoginAttempts(userId) {
            userService
                .resetLoginAttempts(userId)
                .then(() => {
                    this.dialogSuccess(SHORT_DESCRIPTION.USER_UNBLOCKED);
                })
                .catch(e => {
                    this.dialogError(this.$t("plano.errorSetLoginAttempts"));
                });
        },
        save() {
            this.loader = true;

            const profiles = Object.keys(this.seletedProfileByZone)
                .filter(index => this.brandZonesFiltered.some(bz => bz.zone.id == index))
                .map(index => {
                    return { zone: index, profile: this.seletedProfileByZone[index] };
                });

            let request = {
                profiles: this.user.isSuperAdmin ? [] : profiles,
                isSuperAdmin: this.user.isSuperAdmin,
                isClientAdmin: this.isUserClientAdmin,
                brand: cacheService.getCurrentBrandId(),
                userType: this.superadmin ? "0" : this.userType,
                application: this.currentApp
            };

            http.put("/admin/profiles/" + this.$route.params.id + "/user", JSON.stringify(request)).then(resp => {
                if (resp.code) {
                    this.loader = false;
                    this.dialogError(resp.message);
                } else {
                    this.loader = false;
                    this.tmpSeletedProfileByZone = Object.assign({}, this.seletedProfileByZone);
                    this.dialogSuccess(SHORT_DESCRIPTION.USER_UPDATED);
                }
            });
        },
        close() {
            this.$router.push({ path: "/users/user-list" });
        },
        async init() {
            let access = await this.getFunctionalitiesAccess;
            if (this.access === null) this.access = [];
            if (access.admin === true) {
                this.superadmin = true;
            } else {
                let functionalities, roleAccess;
                for (let zoneId in access) {
                    functionalities = access[zoneId];
                    for (let functionalityId in functionalities) {
                        roleAccess = functionalities[functionalityId];
                        let accessUser = {
                            id: roleAccess.access,
                            role: parseInt(roleAccess.role, 10),
                            brand: cacheService.getCurrentBrandId(),
                            functionnality: parseInt(functionalityId, 10),
                            zone: parseInt(zoneId, 10),
                            canValidate: 1
                        };
                        this.access.push(accessUser);
                    }
                }
            }

            this.profiles = await userService.getProfiles();
            let profileAccess = this.getProfileAccess;
            let spz = [];
            this.brandZones.forEach(bz => {
                const pa = profileAccess.find(pa => pa.zoneId === bz.zone.id);
                if (pa) {
                    spz[bz.zone.id] = this.profiles.find(p => p.id === pa.profileId);
                } else {
                    spz[bz.zone.id] = { name: this.$t("userrole.selectProfile") };
                }
            });
            this.seletedProfileByZone = Object.assign({}, spz);
            this.tmpSeletedProfileByZone = Object.assign({}, spz);
            await this.findAllApplications();
            this.accessApplication = this.getAllApplications.filter(app => {
                return this.getBrandAccess.map(access => access.application).includes(app.id);
            });
        },
        async getInfosUser(loader = false) {
            this.loader = loader;
            this.getAllUsersListAction(this.checkedOption ? this.checkedOption : "").then(response => {
                if (response) {
                    this.user = response.find(v => {
                        return parseInt(v.id) === parseInt(this.$route.params.id);
                    });
                    if (loader) {
                        this.loader = false;
                    }
                }
            });
        },
        openModalDeleteBrand() {
            const userBrand = this.user.userBrand.find(ub => ub.brand.id === this.currentBrand.id);
            if (userBrand) {
                this.modalParamsDeleteBrand = {
                    user: this.user,
                    userBrand: userBrand,
                    isActive: true
                };
            }
        },
        openModalChangeAccess() {
            const tmpUser = Object.assign({}, this.user);
            if (tmpUser.isEnabled) {
                tmpUser.isEnabled = false;
            } else {
                tmpUser.isEnabled = true;
            }
            this.modalParamsChangeAccess = {
                user: tmpUser,
                isActive: true
            };
        },
        openModalEditUser() {
            this.modalParamsEditUser = {
                user: this.user,
                isActive: true
            };
        },
        displayTab(appId) {
            return this.isClientAdmin() || this.isSuperAdmin() || this.hasAccessUpdate(FUNCTIONALITY.ZONE, [appId]);
        }
    }
};
</script>

<style lang="scss" scoped>
.admin {
    color: #6f6f6f;
    width: 100%;
    padding: 30px;
    background-color: #fff;
    &-user {
        width: 100%;
        padding: 30px;
        background-color: #f4f4f4;
        &-title {
            font-size: 28px;
            color: #6f6f6f;
            text-transform: uppercase;
            font-family: "Oswald", sans-serif;
        }
        &-manage,
        &-access {
            min-width: 120px;
            span {
                font-size: 24px;
                font-family: "Oswald", sans-serif;
            }
        }
        &-infos {
            table {
                th {
                    white-space: nowrap;
                    vertical-align: baseline;
                    text-transform: uppercase;
                    font-size: 22px;
                    font-weight: normal;
                    font-family: "Oswald", sans-serif;
                }
                td {
                    white-space: nowrap;
                    vertical-align: baseline;
                    font-size: 18px;
                    padding-left: 15px;
                }
            }
        }
    }

    &-role {
        width: 100%;
        &-title {
            font-size: 24px;
            font-family: "Oswald", sans-serif;
        }
        &-switch-client-admin {
            span {
                text-transform: initial;
                font-size: 18px;
            }
        }
        .table-responsive {
            position: relative;
            width: 100%;
        }
        &-table {
            border-collapse: collapse;
            table-layout: auto !important;
            width: 100%;
            overflow-x: scroll;
            overflow-wrap: break-word;
            th {
                vertical-align: bottom;
                overflow-wrap: break-word;
                &.header-profile {
                    padding: 5px 10px;
                    width: 350px;
                }
                padding-bottom: 15px !important;
            }
            td {
                //transition: 0.3s ease-in-out;
                padding: 5px 10px;
                background-color: #f4f4f4;
                border-bottom: 5px solid #fff;
                &.color {
                    width: 20px;
                    padding: 5px;
                }
                &.ref,
                &.name,
                &.zoneGroup {
                    color: #111;
                    font-size: 20px;
                    font-family: "Oswald", sans-serif;
                    @media (max-width: 1440px) {
                        font-size: 18px;
                    }
                }
                &.ref,
                &.name {
                    min-width: 200px;
                    max-width: 350px;
                }
                &.zoneGroup {
                    min-width: 150px;
                    max-width: 250px;
                }
                &.profile {
                    width: 350px;
                }
                &.view-zone {
                    width: 200px;
                }
            }
        }
    }
    .messageAccessBrand {
        font-size: 22px;
    }
    .notfound {
        height: 150px;
        border: #6f6f6f 1px solid;
        span {
            font-size: 16px;
            text-transform: initial;
        }
    }
}
</style>

<style lang="scss">
.admin {
    &-role {
        .nav-tabs {
            .nav-item {
                a {
                    position: relative;
                    color: #111;
                    font-size: 18px;
                    font-weight: normal;
                    text-transform: uppercase;
                    border: #6f6f6f solid 2px;
                    border-bottom: none;
                    background-color: #e9ecef;
                    &.active {
                        background-color: #fff;
                        &:before {
                            content: "";
                            position: absolute;
                            width: 100%;
                            background-color: #fff;
                            left: 0;
                            bottom: -2px;
                            height: 2px;
                        }
                    }
                }
                &:not(:first-child) {
                    a {
                        border-left: none;
                    }
                }
            }
        }
        .tab-content {
            padding: 20px;
            margin: 0 !important;
            border: #6f6f6f solid 2px;
        }

        &-filter {
            .multiselect {
                min-width: 250px;

                .multiselect__single {
                    text-align: center;
                }

                .multiselect__element {
                    text-align: center;
                }

                .multiselect__tags {
                    cursor: pointer;
                }

                .multiselect__option {
                    &.multiselect__option--selected {
                        &.multiselect__option--highlight {
                            text-align: left;
                        }

                        &:not(.multiselect__option--highlight) {
                            &:after {
                                display: none;
                            }
                        }
                    }
                }
            }
        }

        td.profile {
            .multiselect__tags {
                cursor: pointer;
                background-color: #fff !important;
                .multiselect__single {
                    background-color: #fff !important;
                }
                .multiselect__single {
                    text-align: center;
                }
            }
            .multiselect__element {
                text-align: center;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// UserRole.vue?d28ea79c